/**
 * New hire vs rehire.
 *
 * Front-end state, not a form field: it decides which form to *request*, so it
 * has to exist before the schema does.
 */
export type WorkdayHireType = 'new_hire' | 'rehire' | 'conversion';

export const WORKDAY_HIRE_TYPES: {
  value: WorkdayHireType;
  label: string;
}[] = [
  { value: 'new_hire', label: 'New hire' },
  { value: 'rehire', label: 'Rehire' },
  // A contractor at the customer becoming a salaried employee. One form and
  // one submit here; the backend makes two Workday calls behind it.
  { value: 'conversion', label: 'Conversion' },
];

/**
 * Which hire type applies, given what the form said.
 *
 * `rehire_only` means this person is already an employee in Workday, and a new
 * hire would create a second employee record that only a Workday admin can
 * unpick. The choice is removed rather than defaulted — a default is something
 * a recruiter can click past.
 */
export const resolveHireType = (
  chosen: WorkdayHireType | undefined,
  rehireOnly: boolean | undefined
): WorkdayHireType => {
  if (rehireOnly) return 'rehire';
  return chosen ?? 'new_hire';
};

/** True while the recruiter has no say — see `resolveHireType`. */
export const isHireTypeLocked = (rehireOnly: boolean | undefined) =>
  !!rehireOnly;
